import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateReturnOrderFulfillmentMutationVariables = Types.Exact<{
  payload: Types.CreateReturnOrderFulfillmentV2Input;
}>;


export type CreateReturnOrderFulfillmentMutation = { __typename?: 'Mutation', createReturnOrderFulfillmentV2: { __typename?: 'CreateOrderFulfillmentResult', id: string } };


export const CreateReturnOrderFulfillmentDocument = gql`
    mutation CreateReturnOrderFulfillment($payload: CreateReturnOrderFulfillmentV2Input!) {
  createReturnOrderFulfillmentV2(payload: $payload) {
    id
  }
}
    `;
export type CreateReturnOrderFulfillmentMutationFn = Apollo.MutationFunction<CreateReturnOrderFulfillmentMutation, CreateReturnOrderFulfillmentMutationVariables>;

/**
 * __useCreateReturnOrderFulfillmentMutation__
 *
 * To run a mutation, you first call `useCreateReturnOrderFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReturnOrderFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReturnOrderFulfillmentMutation, { data, loading, error }] = useCreateReturnOrderFulfillmentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateReturnOrderFulfillmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateReturnOrderFulfillmentMutation, CreateReturnOrderFulfillmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReturnOrderFulfillmentMutation, CreateReturnOrderFulfillmentMutationVariables>(CreateReturnOrderFulfillmentDocument, options);
      }
export type CreateReturnOrderFulfillmentMutationHookResult = ReturnType<typeof useCreateReturnOrderFulfillmentMutation>;
export type CreateReturnOrderFulfillmentMutationResult = Apollo.MutationResult<CreateReturnOrderFulfillmentMutation>;
export type CreateReturnOrderFulfillmentMutationOptions = Apollo.BaseMutationOptions<CreateReturnOrderFulfillmentMutation, CreateReturnOrderFulfillmentMutationVariables>;